export default __webpack_public_path__ + "static/media/heart.d03a6207.png";